var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtvLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    viewBox: "0 0 279.19 158.78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#ea0029;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 279.19,
    height: 158.78,
    id: "rect1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    clipPath: "url(#clippath)",
    id: "g11"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m168.25,118.66c-3.28-.32-4.93-.47-8.23-.71-.28-.02-.53.17-.64.49-2.04,5.85-4.05,11.71-6.02,17.58-.24.73-1.04.74-1.28.02-2.03-6.08-4.04-12.16-6.04-18.25-.11-.34-.36-.57-.64-.58-3.31-.09-4.97-.12-8.28-.12-.52,0-.86.74-.62,1.37,3.58,9.41,7.17,18.82,10.81,28.2.12.31.36.49.62.48,3.83-.14,5.74-.23,9.56-.48.26-.02.5-.22.62-.53,3.45-8.8,7-17.55,10.76-26.19.24-.54-.1-1.23-.62-1.29",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m114.31,146.61c2.94.2,4.41.28,7.36.41.39.02.7-.38.7-.89v-18.42c0-.51.31-.93.7-.93,3.61-.05,5.42-.07,9.03-.09.39,0,.7-.42.7-.94v-7.7c0-.52-.31-.94-.7-.93-9.41.19-18.78.71-28.16,1.59-.38.04-.69.44-.69.91v6.85c0,.46.31.82.69.81,3.58-.13,5.38-.19,8.98-.28.39-.01.7.38.7.88v17.81c0,.49.31.91.7.94",
    id: "path2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m106.49,46.94c3.81,10.1,7.68,20.18,11.64,30.23,2.5-.07,3.75-.11,6.25-.16,3.86-9.88,7.74-19.75,11.64-29.62v43.23c4.81-.01,7.22.02,12.03.17V26.4c-5.98.19-8.97.22-14.96.15-3.96,10.08-7.92,20.16-11.84,30.25-4-10.4-7.95-20.83-11.82-31.29-5.98-.46-8.97-.75-14.94-1.46v69.08c4.8-.57,7.2-.82,12-1.22v-44.98Z",
    id: "path3",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m76.58,95.72c1.84-.31,2.76-.46,4.61-.75,2.34-2.74,3.51-4.07,5.86-6.66V28.88c-2.34-2.59-3.51-3.92-5.86-6.66-9.65-1.49-19.19-3.49-28.71-5.67-2.33,2.19-3.5,3.31-5.83,5.65,0,24.26,0,48.52,0,72.78,2.33,2.34,3.49,3.47,5.83,5.66,8-1.84,16.01-3.47,24.1-4.92m-17.99-63.01c.53-.52.79-.79,1.32-1.3,5.45.8,8.18,1.16,13.64,1.82.57.62.85.93,1.42,1.55,0,15.91,0,31.83,0,47.74-.57.61-.85.92-1.42,1.55-5.46.66-8.19,1.02-13.64,1.82-.53-.52-.79-.78-1.32-1.3v-51.87Z",
    id: "path4",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m39.44,77.83c-4.76.56-7.14.85-11.88,1.48v10.29c-.56.88-.84,1.33-1.4,2.22-3.59.76-5.38,1.16-8.96,1.99-.03-.03-.04-.05-.07-.09v.1c-1.57.36-2.36.55-3.93.92-.56-.71-.84-1.07-1.39-1.8V24.25c.56-.73.84-1.09,1.39-1.81,1.57.37,2.36.56,3.93.92v.1s.04-.05.07-.09c3.58.82,5.37,1.22,8.96,1.99.56.9.84,1.35,1.4,2.23v10.29c4.75.63,7.12.92,11.88,1.48v-18.76c-2.33-3.5-3.49-5.31-5.81-9.06C24.23,8.7,14.97,5.6,5.76,2.22,3.45,5.03,2.3,6.49,0,9.56v98.08c2.3,3.07,3.45,4.53,5.76,7.34,1.6-.6,2.39-.9,3.99-1.48,6.59-2.34,13.19-4.55,19.86-6.65,1.61-.49,2.41-.73,4.02-1.2,2.32-3.75,3.48-5.56,5.81-9.06v-18.76Z",
    id: "path5",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m183.28,93.63c1.66.21,2.48.33,4.14.56,2.34-1.99,3.51-3,5.85-5.07v-25.34c-2.34-2.43-3.51-3.62-5.85-5.93,2.34-2.33,3.51-3.52,5.85-5.97v-23.81c-2.34-2.07-3.51-3.08-5.85-5.07-5.87.85-11.78,1.54-17.69,2.07-.6.06-.9.08-1.5.13-5.24.46-7.86.64-13.1.91v64.97c5.24.27,7.87.45,13.1.91,5.02.44,10.03.99,15.05,1.64m-16.04-57.74c.4-.02.6-.04.99-.06.6-.04.9-.05,1.5-.09,4.09-.26,6.14-.4,10.23-.74.53.5.79.75,1.32,1.26v14.74c-.53.56-.79.84-1.32,1.4-4.09.09-6.13.13-10.23.19-.6.01-.9.01-1.5.02-.4,0-.6.01-.99.02v-16.74Zm0,27.52c.4,0,.6,0,.99.01.6,0,.9.01,1.5.02,4.09.05,6.14.09,10.23.16.53.52.79.78,1.32,1.31v15.74c-.53.51-.79.76-1.32,1.26-4.09-.33-6.13-.48-10.23-.73-.77-.05-1.48-.09-2.49-.15v-17.62Z",
    id: "path6",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m238.23,12.62v14.88c5.63-.98,8.43-1.5,14.04-2.61v83.54c5.2,1.52,7.79,2.32,12.97,4V22.19c5.59-1.23,8.38-1.87,13.94-3.22V0c-13.5,4.72-27.09,8.92-40.96,12.62",
    id: "path7",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.95,18.46c-5.25,25.78-10.88,51.46-16.95,77.06,4.9.81,7.35,1.26,12.25,2.25,1.09-5.51,2.15-11.01,3.2-16.53,5.87.7,8.81,1.09,14.66,1.93,1.07,6.49,2.14,12.98,3.18,19.47,4.88,1.28,7.32,1.96,12.18,3.4-5.13-30.18-10.7-60.28-16.87-90.27-4.66,1.15-6.99,1.69-11.65,2.69m.84,50.01c1.7-9.21,3.36-18.42,4.99-27.65,1.69,9.4,3.35,18.8,4.97,28.21-3.98-.24-5.97-.35-9.96-.56",
    id: "path8",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m234.63,123.56l-56.68-10.2h0v3.27l3.43.42v8.33l-3.43-.26v2.83l3.43.09v8.53l-3.43.09v2.83l3.43-.26v8.33l-3.43.42v3.08c0,.07-.01.13-.02.19l56.69-10.2-51.1,6.24v-8.23l51.1-3.85-51.1,1.3v-8.42l51.1,1.3-51.1-3.85v-8.23l51.1,6.24Z",
    id: "path9",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m94.68,147.91l-4.13-.5v-8.33l4.04.3.09-.03v-2.82l-4.13-.1v-8.53l4.13-.1v-2.82l-.09-.03-4.04.3v-8.33l4.13-.5v-3.02c0-.1.02-.2.03-.3l-57.4,10.33,51.1-6.24v8.23l-51.1,3.85,51.1-1.29v8.42l-51.1-1.29,51.1,3.85v8.23l-51.1-6.24,57.39,10.33c0-.05-.01-.11-.01-.16v-3.16Z",
    id: "path10",
    style: {
      fill: "#011ca8",
      fillOpacity: 1
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m177.95,147.99v-34.62h0c0-1.77-1.27-3.49-2.85-3.83-25.88-5.18-51.7-5.18-77.58,0-1.49.32-2.69,1.87-2.82,3.53,0,.1-.03.2-.03.3v37.7c0,.05.01.1.01.16.07,1.71,1.31,3.34,2.83,3.67,25.89,5.18,51.7,5.18,77.58,0,1.52-.32,2.74-1.94,2.83-3.63,0-.07.02-.13.02-.19v-3.08Zm-65.04-21c-3.6.09-5.4.15-8.98.28-.38.01-.69-.35-.69-.81v-6.85c0-.46.31-.87.69-.91,9.38-.87,18.75-1.4,28.16-1.59.39,0,.7.41.7.93v7.7c0,.52-.31.94-.7.94-3.62.02-5.42.03-9.03.09-.39,0-.7.42-.7.93v18.42c0,.51-.31.91-.7.89-2.95-.13-4.42-.22-7.36-.41-.39-.03-.7-.45-.7-.94v-17.81c0-.49-.31-.88-.7-.87m55.96-7.05c-3.76,8.65-7.31,17.39-10.76,26.19-.12.31-.36.51-.62.53-3.82.25-5.73.35-9.56.48-.26.01-.5-.18-.62-.48-3.64-9.38-7.23-18.79-10.81-28.2-.24-.63.1-1.37.62-1.37,3.31,0,4.97.03,8.28.12.28,0,.53.23.64.58,2,6.09,4.01,12.17,6.04,18.25.24.73,1.03.72,1.28-.02,1.98-5.88,3.98-11.74,6.02-17.58.11-.32.36-.51.64-.49,3.3.24,4.94.38,8.23.71.52.05.86.75.62,1.28",
    id: "path11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvLogoColor);
export default __webpack_public_path__ + "static/media/CTV-Logo-color.c4e55cbe9349551b8489f9d607df3458.svg";
export { ForwardRef as ReactComponent };